export const getFullDate = (date) => {
  const formatDate = new Date(date)
  const month = formatDate.getMonth() + 1
  const day = formatDate.getDate()
  return `${day < 10 ? '0' + day : day}.${
    month < 10 ? '0' + month : month
  }.${formatDate.getFullYear()}`
}
